import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M20 9.49922C20 10.09 19.8824 10.675 19.6541 11.2207C19.4258 11.7665 19.0908 12.2624 18.669 12.68L12.4936 18.7974C12.2208 19.0675 11.7785 19.0676 11.5057 18.7974L5.33032 12.6804C4.4786 11.8367 4.00002 10.6923 4 9.49922C4 8.30607 4.47858 7.16175 5.33032 6.31807C6.18206 5.4744 7.33732 5.00034 8.54185 5.00034C9.74635 5.00037 10.9017 5.47442 11.7534 6.31807L11.9997 6.56202L12.2463 6.31807L12.3261 6.2407C12.7306 5.85915 13.2029 5.55464 13.7195 5.34261C14.2706 5.11644 14.8613 5 15.4578 5C16.0543 5.00001 16.6451 5.11645 17.1961 5.34261C17.7471 5.56877 18.2477 5.90024 18.6693 6.31807C19.0912 6.73576 19.4258 7.23154 19.6541 7.77738C19.8824 8.32321 20 8.90839 20 9.49922Z" }, null, -1)
  ]))]))
}
export default { render: render }